type LogLevel = 'debug' | 'info' | 'warn' | 'error';

const isDev = import.meta.env.DEV;

function formatMessage(level: LogLevel, tag: string, message: string): string {
  return `[${tag}] ${message}`;
}

export const logger = {
  debug: (tag: string, message: string, ...args: unknown[]) => {
    if (isDev) {
      console.log(formatMessage('debug', tag, message), ...args);
    }
  },

  info: (tag: string, message: string, ...args: unknown[]) => {
    if (isDev) {
      console.info(formatMessage('info', tag, message), ...args);
    }
  },

  warn: (tag: string, message: string, ...args: unknown[]) => {
    console.warn(formatMessage('warn', tag, message), ...args);
  },

  error: (tag: string, message: string, ...args: unknown[]) => {
    console.error(formatMessage('error', tag, message), ...args);
  },
};
